'use client'
import { GTMNewsDetailTracker } from '@/app/[lng]/components/GTMTrackers/GTMNewsTracker'
import useConsentCheck from '@/app/hooks/useConsentCheck'
import { NewsItem } from '@/app/types/newsType'
import { languageTransition } from '@/app/utils/language'
import { useParams } from 'next/navigation'
import { useEffect } from 'react'

const NewsDetailGTMTracker = ({ newsDetails }: { newsDetails: NewsItem }) => {
  const consentUserValue = useConsentCheck()

  const params = useParams<{ lng: string }>()
  const languagePath =
    languageTransition.find(
      (lang) => lang.language === newsDetails?.language?.name
    )?.path || 'en'

  useEffect(() => {
    GTMNewsDetailTracker(
      Number(newsDetails?.company_id),
      languagePath,
      params?.lng ?? 'en',
      newsDetails?.id,
      consentUserValue()
    )
  }, [])

  return null
}

export default NewsDetailGTMTracker
